import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const CustomMuiAlert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


/**
 * success, error, warning, info
 */
export default function Alert({ open, onClose, message, type = "success" }) {

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    onClose();
  };

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <CustomMuiAlert onClose={handleClose} severity={type} sx={{ width: '100%' }}>
        {message}
      </CustomMuiAlert>
    </Snackbar>
  );
}
